import script from "./RandomName.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomName.vue?vue&type=script&setup=true&lang=js"

import "./RandomName.vue?vue&type=style&index=0&id=5dc54d33&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc54d33"]])

export default __exports__